import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import GenericButton from '../common/GenericButton';
import DynamicDataGrid from '../common/DynamicDataGrid/DynamicDataGrid';
import Modal from '../common/Modal/Modal';
import * as crosstabActions from '../../actions/crosstabActions';
import deleteIcon from '../../images/small-x-icon_l.png';

const modalStyle = {
  top: '5%',
  marginTop: '25%',
  width: '50%',
  height: '400px',
  left: '30%',
};

class SavedCrosstabs extends Component {
  constructor(props) {
    super(props);
    this.deleteHandler = this.deleteHandler.bind(this);
  }

  getSavedCrosstabColumns() {
    const gridColumns = [];
      gridColumns.push({ key: 'title', name: 'Name', sortable: true });
      gridColumns.push({
        key: 'lastModified',
        sortKey: 'lastModifiedSortable',
        name: 'Updated',
        sortable: true,
        width: 200,
        formatter: props => (
          <div>
            {props.value}
            <button type="button" className="btn-x" onClick={() => this.deleteHandler()}>
              <img title="Delete" src={deleteIcon} alt="delete" />{' '}
            </button>
          </div>
        ),
      });
      return gridColumns;
  }

  handleLoadCrosstab = () => {
    const savedCrosstabGridObj = this.savedCrosstabGrid.getDecoratedComponentInstance();
    if (!this.props.handleLoadCac) {
      const entry = savedCrosstabGridObj.getSelectedEntries()[0];
      if (entry) {
        this.props.updateCrosstabTitle(entry.title);
        this.props.crosstabActions.loadSavedCrosstab(
          this.props.loginResponse.data.token,
          this.props.loginResponse.data.uid,
          this.props.activeAccountId,
          entry.id,
        );
        this.props.closeLoadCrosstabModal();
      }
    } else if (this.props.handleLoadCac) {
      const entries = savedCrosstabGridObj.getSelectedEntries();
      this.props.handleLoadCac(entries);
    }
  };

  handleConfirmDelete = () => {
    const savedCrosstabGridObj = this.savedCrosstabGrid.getDecoratedComponentInstance();
    if (savedCrosstabGridObj.getSelectedEntries()[0]) {
      this.confirmDeleteModal.show();
    }
  };

  handleDeleteCrosstab = () => {
    const savedCrosstabGridObj = this.savedCrosstabGrid.getDecoratedComponentInstance();
    if (savedCrosstabGridObj.getSelectedEntries()[0]) {
      const id = savedCrosstabGridObj.getSelectedEntries()[0].id;
      this.props.crosstabActions.deleteSavedCrosstabs(
        this.props.loginResponse.data.token,
        this.props.loginResponse.data.uid,
        this.props.activeAccountId,
        id,
      );
    }
    this.confirmDeleteModal.hide();
  };

 

  closeLoadCrosstabModal = () => this.props.closeLoadCrosstabModal();

  deleteHandler = () => {
    this.handleConfirmDelete();
  };

  render() {
    return (
      <div>
        <div className="row">
          <div className="large-12">
            <DynamicDataGrid
              ref={node => (this.savedCrosstabGrid = node)}
              gridCategory="SaveCrosstabGrid"
              className="saved-crosstab-grid saved-crosstab-width"
              rows={this.props.rowData}
              columns={this.getSavedCrosstabColumns()}
              rowSelectionType={this.props.rowSelectionType ? this.props.rowSelectionType : 'Single'}
              isCellSelectable
              minimunRows={5}
            />
          </div>
        </div>
        <div className="row">
          <div className="row-margin-top-10px">
            <div className="large-3 float-right text-right">
              <GenericButton
                name="Load"
                btnStyle="button load-btn"
                onBtnClick={() => this.handleLoadCrosstab()}
              />
            </div>
          </div>
        </div>
        <Modal
          title="Confirm Delete"
          ref={node => (this.confirmDeleteModal = node)}
          dialogStyles={modalStyle}
        >
          <div className="large-12 columns">
            <div>
              Are you sure you want to delete this crosstab?
              <div className="row column">
                <div className="large-6 text-center columns">
                  <GenericButton
                    name="Yes"
                    btnStyle="button button-125px"
                    onBtnClick={() => this.handleDeleteCrosstab()}
                  />
                </div>
                <div className="large-6 text-center columns">
                  <GenericButton
                    name="No"
                    btnStyle="button btn-cncl button-125px"
                    onBtnClick={() => this.confirmDeleteModal.hide()}
                  />
                </div>
              </div>
            </div>
          </div>
        </Modal>
      </div>
    );
  }
}
function mapStateToProps(state) {
  return {
    loginResponse: state.login.loginResponse,
    activeAccountId: state.account.activeAccountId,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    crosstabActions: bindActionCreators(crosstabActions, dispatch),
  };
}
SavedCrosstabs.propTypes = {
  rowData: PropTypes.arrayOf(PropTypes.object),
  crosstabActions: PropTypes.shape({
    loadSavedCrosstab: PropTypes.func,
    deleteSavedCrosstabs: PropTypes.func,
  }),
  loginResponse: PropTypes.shape({
    data: PropTypes.shape({
      uid: PropTypes.number,
      token: PropTypes.string,
    }),
  }),
  activeAccountId: PropTypes.number,
  closeLoadCrosstabModal: PropTypes.func,
  updateCrosstabTitle: PropTypes.func,
};
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(SavedCrosstabs);
